import { IconButton, makeStyles } from '@material-ui/core'
import React from 'react'
import { useRef } from 'react'
import { Tree } from 'react-arborist'
import { AutoSizer } from 'react-virtualized'
import ArrowRightIcon from '@material-ui/icons/Input'

import Input from 'web/src/app/root/components/common/input'
import { DeviceTreeNode } from './device-tree-node'
import { useSelector } from 'react-redux'
import { Loading } from 'web/src/app/root/components/common'
import {
    treeNodeChildrenAccessor,
    treeNodeIdAccessor
} from 'web/src/app/root/components/common/locations-tree/tree-utils'

export const DevicesTree = ({
    treeUtils,
    onIconClick,
    onSearch,
    allExpanded,
    search,
    isLoading
}) => {
    const classes = useStyles()
    const treeRef = useRef()
    const { locale, theme } = useSelector(state => state.main)

    return (
        <div className={classes.root}>
            {onSearch && (
                <div className={classes.searchInputWrapper}>
                    <Input
                        size="small"
                        autoFocus
                        label={locale.common.search}
                        type="text"
                        setValue={onSearch}
                        debounce={600}
                    />
                </div>
            )}
            {treeUtils.hasChildren || isLoading ? (
                <div className={classes.locationsWrapper}>
                    {isLoading ? (
                        <Loading />
                    ) : (
                        <AutoSizer>
                            {({ width, height }) => {
                                return (
                                    <Tree
                                        ref={treeRef}
                                        openByDefault={allExpanded}
                                        height={height}
                                        width={width}
                                        indent={20}
                                        rowHeight={37}
                                        data={treeUtils.data?.children || []}
                                        idAccessor={treeNodeIdAccessor}
                                        childrenAccessor={
                                            treeNodeChildrenAccessor
                                        }>
                                        {props => (
                                            <DeviceTreeNode
                                                search={search}
                                                icon={
                                                    <IconButton
                                                        size="small"
                                                        onClick={() =>
                                                            onIconClick(
                                                                props.node.data
                                                            )
                                                        }>
                                                        <ArrowRightIcon
                                                            htmlColor={
                                                                props.node
                                                                    .isSelected
                                                                    ? theme.textPrimaryReverted
                                                                    : theme.primary
                                                            }
                                                        />
                                                    </IconButton>
                                                }
                                                {...props}
                                            />
                                        )}
                                    </Tree>
                                )
                            }}
                        </AutoSizer>
                    )}
                </div>
            ) : (
                <div>{locale.locations.noDevicesToAddFound}</div>
            )}
        </div>
    )
}

const useStyles = makeStyles(theme => ({
    root: {
        height: 'calc(100% - 28px)'
    },
    locationsWrapper: {
        width: '100%',
        height: 'calc(100% - 65px)'
    },
    searchInputWrapper: {
        paddingRight: 12,
        marginBottom: 8
    }
}))
